import React, { useContext } from "react";
import { AuthContext } from "../Provider/AuthProvider";
import { useNavigate } from "react-router-dom";

const Profile = () => {
    const { user, logout, loading } = useContext(AuthContext);
    const navigate = useNavigate();

    // const [emailOffers, setEmailOffers] = useState(true);
    // const [smsUpdates, setSmsUpdates] = useState(true);

    if (loading) {
        return <div>Loading...</div>;
    }
    
    if (!user) {
        // Optional: redirect if not logged in
        navigate("/login");
        return null;
    }



    return (
        <div className="flex justify-center items-center min-h-screen bg-red-50">
            <div className="bg-white p-8 rounded-2xl shadow-md w-full max-w-lg">
                <h2 className="text-2xl font-bold text-red-700 mb-6 text-center">
                    👤 My Profile
                </h2>

                {/* User Info */}
                <div className="space-y-4">
                    <div>
                        <p className="text-sm text-gray-500">Full Name</p>
                        <p className="font-medium">{user.name || "Not provided"}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">Email</p>
                        <p className="font-medium">{user.email}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">Phone</p>
                        <p className="font-medium">{user.phone_no || "Not provided"}</p>
                    </div>

                    <div>
                        <p className="text-sm text-gray-500">Postcode</p>
                        <p className="font-medium">{user.postcode || "Not provided"}</p>
                    </div>

                    {/* <div>
                        <p className="text-sm text-gray-500">Member Since</p>
                        <p className="font-medium">{new Date(user.created_at).toLocaleDateString() || "N/A"}</p>
                    </div> */}
                </div>

                {/* Divider */}
                <div className="my-6 border-t border-gray-300"></div>

                {/* Preferences */}
                {/* <h3 className="text-lg font-semibold text-red-700 mb-3">
                    📩 Preferences
                </h3>
                <div className="space-y-2 text-sm text-gray-700">
                    <label className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            checked={emailOffers}
                            onChange={() => setEmailOffers(!emailOffers)}
                            className="text-red-600"
                        />
                        <span>Receive offers & coupons by Email</span>
                    </label>
                    <label className="flex items-center space-x-2">
                        <input
                            type="checkbox"
                            checked={smsUpdates}
                            onChange={() => setSmsUpdates(!smsUpdates)}
                            className="text-red-600"
                        />
                        <span>Receive updates by SMS</span>
                    </label>
                </div> */}

                {/* Buttons */}
                <div className="mt-6 flex flex-col sm:flex-row gap-3">
                    <button
                        onClick={() => navigate("/edit-profile")}
                        className="flex-1 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition"
                    >
                        Edit Profile
                    </button>
                    <button
                        onClick={() => {
                            logout();
                            navigate("/login");
                        }}
                        className="flex-1 border border-red-600 text-red-600 py-2 rounded-lg hover:bg-red-100 transition"
                    >
                        Log Out
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Profile;
